import useQuestionnaireCurrentStepState from 'app/hooks/useQuestionnaireCurrentStepState';
import { CheckboxInput } from 'Components/Auth/CheckboxInput';
import Form from 'Components/Form';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { setTabValidationState } from '../../routes/slice';
import { useValidateQuestionnaireForm } from '../useValidateQuestionnaire';

import { selectSummaryAgreement, update } from './slice';

export interface IConfirmSummaryProps {}

export const validationSchema = Yup.object().shape({
  agreement: Yup.boolean().oneOf([true], 'required'),
});

export function useValidateSummaryForm() {
  const values = useSelector(selectSummaryAgreement);

  return useValidateQuestionnaireForm('summary', values, validationSchema);
}

export default function ConfirmSummary(props: IConfirmSummaryProps) {
  const dispatch = useDispatch();
  const summaryValues = useSelector(selectSummaryAgreement);
  const { isValid } = useQuestionnaireCurrentStepState();

  const handleOnAgreementChange = (payload: { key: string; value: any }) => {
    dispatch(update({ agreement: payload.value }));
    dispatch(
      setTabValidationState({ dotPath: 'summary', isValid: payload.value }),
    );
    dispatch(
      setTabValidationState({
        dotPath: 'summary.summary',
        isValid: payload.value,
      }),
    );
  };
  return (
    <div className=" shrink-0 p-4 border-t border-gray-800 bg-gray-400 ">
      <Form
        defaultValues={summaryValues}
        onSubmit={() => {}}
        validationSchema={validationSchema}
        validationMode="all"
        isValid={isValid}
        className="flex flex-col items-center h-full my-2 py-2"
      >
        {({ formState: { errors } }) => (
          <>
            <CheckboxInput
              type="checkbox"
              name="agreement"
              label={() => (
                <p>
                  I confirm that I agree with the above summary.  Also, I
                  acknowledge and understand that my income tax returns will
                  remain incomplete and not be filed electronically without my
                  signature approval on the return.
                </p>
              )}
              effect={handleOnAgreementChange}
            />
          </>
        )}
      </Form>
    </div>
  );
}
